export default {
  drainedWeights: [],
  drainedWeight: undefined,
};
